import React, { useEffect, useState } from 'react';
import { NAV_LINKS, OFFER_ANCHOR, TOP_BAR_ITEMS } from '../data/catio';

/**
 * Slim moving announcement ribbon + compact sticky header.
 * On mobile the header stays minimal so the hero CTA fits the first viewport.
 */
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Four copies per half keep the loop seamless on wide screens.
  const half = [...TOP_BAR_ITEMS, ...TOP_BAR_ITEMS, ...TOP_BAR_ITEMS, ...TOP_BAR_ITEMS];
  const track = [...half, ...half];
  return <>
      <div className="marquee overflow-hidden border-b border-[#D9C4A6] bg-ticker text-[#2C2925]" data-id="element-89" data-mp="25xbhv601ag3z">
        <p className="sr-only" data-id="element-90" data-mp="3ldk1z0xv2iqx">{TOP_BAR_ITEMS.join(' · ')}</p>
        <div className="animate-marquee flex w-max items-center py-[4px]" aria-hidden data-id="element-91" data-mp="3h9kq4vnj083w">
          {track.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap font-tech text-[11px] font-semibold uppercase tracking-[0.18em] text-[#2C2925]" data-id="element-92" data-mp="1bylid4xmqtak" data-mpi={index}>
              {item}
              <span className="mx-8 h-1 w-1 rotate-45 bg-ember sm:mx-10" data-id="element-93" data-mp="1pwa5ykj30ejb" />
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-line bg-ivory/95 backdrop-blur' : 'border-transparent bg-ivory'}`} data-id="element-94" data-mp="t7c64nwh5qfa">
        <div className="mx-auto flex h-12 w-full max-w-6xl items-center justify-between gap-4 px-5 sm:h-14 sm:px-8" data-id="element-95" data-mp="124cu4tfmtmi7">
          <a href="#top" className="flex items-baseline" aria-label="CATIO READY™ — back to top" data-id="element-96" data-mp="9hs1lpnf74d2">
            <span className="wordmark text-[1.25rem] text-ink sm:text-[1.4rem]" data-id="element-97" data-mp="egv87ej1tin5">
              Catio <span className="text-ember" data-id="element-98" data-mp="eeij8hevi80l">Ready</span>
              <sup className="ml-0.5 text-[0.45em]" data-id="element-99" data-mp="1hqhiflmswqvh">™</sup>
            </span>
          </a>

          <nav aria-label="Sections" className="hidden items-center gap-7 lg:flex" data-id="element-100" data-mp="1crmq9t2y1pyp">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-[0.86rem] font-medium text-graphite transition-colors duration-150 ease-out hover:text-ink" data-id="element-101" data-mp="1qjb01ppq02ci">
                {link.label}
              </a>)}
          </nav>

          <a href={OFFER_ANCHOR} className="hidden min-h-[40px] items-center rounded-[12px] bg-ember-cta px-4 text-[0.76rem] font-bold uppercase tracking-[0.05em] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.45),inset_0_8px_14px_-8px_rgba(255,214,180,0.5)] transition-colors duration-150 ease-out hover:bg-ember-deep sm:inline-flex" data-id="element-102" data-mp="tvo7w3zoj64v">
            Get the Collection
          </a>
        </div>
      </header>
    </>;
}